import { taskDetail } from "@/api/taskCenter";
import { Message } from "element-ui";
export function exportLoop(tid: number, step?: number, callback?: Function) {
  const loop = setInterval(() => {
    taskDetail({ task_id: tid })
      .then((taskRes: any) => {
        if (taskRes.error_code === 0) {
          if (taskRes.data.status === 1) {
            Message({
              showClose: true,
              message: "导出成功",
              type: "success",
            });
            if (callback) {
              callback("success");
            }
            clearInterval(loop);
            // const link = document.createElement("a");
            // link.style.display = "none";
            // link.href = taskRes.data.link;
            // link.setAttribute("download", taskRes.data.title);
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            fetch(taskRes.data.link)
              .then((res) => res.blob())
              .then((blob) => {
                const a = document.createElement("a");
                document.body.appendChild(a);
                a.style.display = "none";
                // 使用获取到的blob对象创建的url
                const url = window.URL.createObjectURL(blob);
                a.href = url;
                // 指定下载的文件名
                a.download = taskRes.data.title;
                a.click();
                document.body.removeChild(a);
                // 移除blob对象的url
                window.URL.revokeObjectURL(url);
              })
              .catch(() => {
                Message({
                  showClose: true,
                  message: "导出失败",
                  type: "error",
                });
                if (callback) {
                  callback("error");
                }
              });
          }
          if (taskRes.data.status === 2) {
            Message({
              showClose: true,
              message: "导出失败",
              type: "error",
            });
            if (callback) {
              callback("error");
            }
            clearInterval(loop);
          }
        } else {
          clearInterval(loop);
        }
      })
      .catch(() => {
        clearInterval(loop);
      });
  }, step || 600);
}
